import { BackednResponse } from "@shared/lib/types";
import { useQuery } from "@tanstack/react-query";
import { BriefService } from "../services/brief.service";
import {
  IBriefInfluencerSearchRequestV2,
  IBriefInfluencerSearchRequestV2WithoutBriefId,
  IGetBriefInfluencersV2Response,
} from "@shared/lib/types/briefInfluencerV2";
import { BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY } from "../constants";
import { useEffect } from "react";
import { ToastService } from "@shared/lib/services";

export function useGetBriefInfluencersV2withoutBriefId(
  params: IBriefInfluencerSearchRequestV2WithoutBriefId
) {
  const { data, isLoading, isError, error, refetch } = useQuery<
    BackednResponse<IGetBriefInfluencersV2Response>
  >({
    queryKey: [...BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY, params],
    queryFn: () => BriefService.getBriefInfluencersV2WithoutBriefId(params),
  });

  const errorMessage = isError && error?.message;

  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    briefInfluencers: data?.data,
    isFetching: isLoading,
    isError,
    refetch,
  };
}
